import CryptoJS from "crypto-js";

export const getDecryptedUserFromCookie = () => {
  try {
    const encryptedUser = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12eccom"));
    if (!encryptedUser) {
      console.warn("⚠️ No encrypted data found.");
      return null;
    }

    const secret = process.env.REACT_APP_CRYPTO_SECRET;
    if (!secret) {
      throw new Error("Missing REACT_APP_CRYPTO_SECRET");
    }

    const bytes = CryptoJS.AES.decrypt(encryptedUser, secret);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) throw new Error("Decryption returned empty string");

    return JSON.parse(decryptedText);
  } catch (err) {
    console.error("❌ Decryption or parsing failed:", err);
    return null;
  }
};
